/* 
  IntersectionObserverで要素を監視
  スクロールに合わせて動きを追加する
---------------------------------------------- */
export const OBSERVER = {
  init: function () {
    const observeTargets = document.querySelectorAll('.observe_item')

    // 監視対象になった要素にis-fade-upを付与する関数
    const setItemActive = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-fade-up')
        }
      })
    }

    const options = {
      root: null,
      rootMargin: '100px 0px',
      threshold: 0.3,
    }

    const observer = new IntersectionObserver(setItemActive, options)

    observeTargets.forEach(target => {
      observer.observe(target)
    })
  },
}
